class PersistentBanner extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback () {
    this.section_id = this.getAttribute("data-section-id");
    const user_default_state = sessionStorage.getItem(this.section_id);  

    this.toggle = this.querySelector('.collapsible-row--toggle');
    this.default_state = 'true' === this.toggle.getAttribute('aria-expanded');   
    if (user_default_state != null) {
      this.default_state = 'true' === user_default_state;
    }     

    this.description = this.querySelector('.collapsible-row--content');    
    this.description_wrapper = this.querySelector('.collapsible-row--content-wrapper');

    this.toggleListener();
    this.setTransitions(this.default_state);

    // Add click tracking to persistent banner links
    this.addClickTracking();
  }

  disconnectedCallback () {
    this.toggle.off('click keydown')
  }

  toggleListener () {
    const section_id = this.section_id;
    this.toggle.on('click keydown', e => {
      console.log('click');
      const set_state = ('true' !== this.toggle.getAttribute('aria-expanded'));
      ('keydown' === e.type && 'Enter' !== e.key) ||
        (e.preventDefault(),
         sessionStorage.setItem(section_id, set_state),
         this.setTransitions(set_state));
    })
  }

  setTransitions (e) {
    this.toggle.setAttribute('aria-expanded', e),
    this.description_wrapper.setAttribute('data-transition-active', e),
    (this.description_wrapper.style.height = e
      ? this.description.offsetHeight + 'px'
      : '30px')
  }

  // New function for click tracking
  addClickTracking() {
    // Track clicks on each link in the persistent banner with the custom class
    this.querySelectorAll('.persistent-banner-link').forEach(function(link) {
      link.addEventListener('click', function() {
        // Custom event data
        var bannerCategory = link.textContent.trim();  // Capture the link text (SHOP NEW, SHOP SALE, etc.)

        // Log when the click tracking is working
        console.log('Persistent banner link clicked:', bannerCategory);

        // Save the click event to sessionStorage to persist through page load
        sessionStorage.setItem('persistentBannerClickTracked', 'true');

        // Send the custom event to Shopify Analytics
        try {
          window.ShopifyAnalytics.lib.track('persistent_banner_click', {
            source: 'Persistent Banner',
            category: bannerCategory,
            link: link.href  // The URL being clicked
          });
          console.log('Click successfully tracked');
        } catch (e) {
          console.log('Error tracking click:', e);
        }
      });
    });
  }
}

// Check for the tracking flag after page load
window.addEventListener('load', function() {
  if (sessionStorage.getItem('persistentBannerClickTracked') === 'true') {
    console.log('Persistent banner click was successfully tracked!');
    sessionStorage.removeItem('persistentBannerClickTracked'); // Remove the flag after confirming
  } else {
    console.log('No persistent banner click tracked on this page.');
  }
});

const persistBannerEl = customElements.get('persistent-banner')
persistBannerEl || customElements.define('persistent-banner', PersistentBanner)
